import { gql } from "@stadium/services/apollo-client";

export const UPDATE_PROFILE = gql`
  mutation updateProfile($input: UserUpdateProfileInput!) @api(name: "users") {
    updateProfile(input: $input) {
      success
      user {
        id: spreeId
        profile {
          id
          lowFundsNotificationThreshold
          personalWorkspaceNudgeLastDismissedAt
        }
      }
    }
  }
`;
